import React from "react";
import TextSuitIcon from "../../../../Custom-imeges/Workflows-Icons/TextSuitIcon";
import { OutputSettingProps } from "../../../../Types/Workflow-Types";

const OutputSettingText = ({readOnly}:OutputSettingProps) => {
  return (
    <span className="typeInput-output" style={{ opacity: 0.7 }}>
      <span className="me-1" style={{ opacity: 0.7 }}>
        <TextSuitIcon className="custom-icon" size="17" />
      </span>
      <span className="ms-1">Text</span>
    </span>
  );
};

export default OutputSettingText;
